interface AcceptDefaultsResult {
  accepted?: string[];
  count?: number;
}

interface AcceptDefaultsBadgeProps {
  result: unknown;
}

/**
 * Inline badge for the `accept_defaults` tool — extracted from
 * ToolResultRenderer's inline JSX in Phase 2 Session 3. Renders only when
 * count > 0; null otherwise.
 */
export function AcceptDefaultsBadge({ result }: AcceptDefaultsBadgeProps) {
  const r = result as AcceptDefaultsResult | null | undefined;
  const count = r?.count ?? r?.accepted?.length ?? 0;
  if (count === 0) return null;
  return (
    <div className="flex items-center gap-2">
      <span className="text-[10px] font-mono font-semibold px-1.5 py-px rounded-[2px] border text-accent/70 bg-accent-dim border-accent/15">
        DEFAULTS
      </span>
      <span className="text-xs font-mono text-text-muted">
        Accepted {count} default{count !== 1 ? 's' : ''} as reviewed
      </span>
    </div>
  );
}
